import { getTreeItem } from "../MenuItems/MenuItemTreeView/utils";
import MenuItemForm from "./MenuItemForm";
import RecentListForm from "./RecentListForm";
import RecentRecordsForm from "./RecentRecordsForm";

function EditItemForm(props) {

    const item = getTreeItem(props.menuItems, props.selectedItemIndex);
    const parentMenuItem = getTreeItem(props.menuItems, props.selectedItemIndex.split("_")[0]);

    switch (item.type) {
        case "Recent Records":
            return <RecentRecordsForm {...props} parentMenuItemId={parentMenuItem.id} itemId={item.id} properties={item} />
        case "Recent Lists":
            return <RecentListForm {...props} parentMenuItemId={parentMenuItem.id} itemId={item.id} properties={item} />
        default:
            return <MenuItemForm {...props} itemId={item.id} properties={item} />
    }
}

export default EditItemForm;